import { CanMatchFn } from '@angular/router';

import { FeatureFlag, isFeatureEnabled } from './feature-flags';

export function featureFlagGuard(flag: FeatureFlag): CanMatchFn {
  return () => isFeatureEnabled(flag);
}
